import {
  ClientReportDetailSectionDocument,
  ClientReportDetailSectionQuery,
  SaveClientReportMetaDeliveryMutation,
  SaveMetaDelivery_Input,
  useSaveClientReportMetaDeliveryMutation
} from 'generated/graphql';
import _ from 'lodash';
import { gqlCacheUtil } from 'modules/common';
import React from 'react';



export function useSaveClientReportItem() {
  const [
    fnMutate,
    tuple
  ] = useSaveClientReportMetaDeliveryMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SaveMetaDelivery_Input) => {
      await fnMutate({
        variables: {
          input
        },
        updateQueries: {
          ...gqlCacheUtil.genUpdateQueryMap<ClientReportDetailSectionQuery, SaveClientReportMetaDeliveryMutation>(ClientReportDetailSectionDocument, (prevState, mutationResult) => {
            if (!input || !prevState.clientReport?.id || !mutationResult.mutationResult.data?.saveMetaDelivery) {
              return prevState;
            }

            const updatedDeliveries = prevState.clientReport?.deliveries.map((node) => {
              const found = node.id === input.id;
              if (found) {
                return {
                  ...node,
                  ...mutationResult.mutationResult.data?.saveMetaDelivery
                };
              }
              return node;
            });

            return {
              ...prevState,
              clientReport: {
                ...prevState.clientReport,
                deliveries: _.compact(updatedDeliveries)
              }
            };

          })
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
